
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/cookie-policy",
      function () {
        return require("private-next-pages/customer-service/cookie-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/cookie-policy"])
      });
    }
  